import { useTheme, Box, Typography } from "@mui/material";
import { useColorMode, useColors } from "../../theme";
import React from "react";

const Footer = React.memo(() => {
    const theme = useTheme();
    const { toggleColorMode } = useColorMode();
    const colors = useColors();

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2, // Adjust padding as needed
            borderTop: '1px solid #efefef',
            maxHeight: '100px', // Set maximum height
            flexShrink: 0, // Prevent it from shrinking
        }}>
            {/* Left Side (Empty for now) */}
            <Box display="flex"></Box>

            {/* Center Text */}
            <Box alignSelf="center" display="flex">
                <Typography variant="h5">Footer</Typography>
            </Box>

            {/* Right Side (Empty for now) */}
            <Box display="flex"></Box>
        </Box>
    );
});

export default Footer;